<script setup lang="ts">
  import { PageDecorationImage } from '@/shared/ui/components'

  import { useProfile } from '@/entities/profile'

  import { EventsList } from '@/features/events'

  const { t } = useI18n()

  definePage({
    meta: { layout: 'baseNew' },
  })

  useHead({
    title: () => t('navigation_item_announcements'),
  })

  const router = useRouter()
  const route = useRoute()

  const { isProbationPassed } = storeToRefs(useProfile())

  if (!isProbationPassed.value) {
    router.push('/')
  }

  const { isAdmin, isContentManager } = storeToRefs(useProfile())
  const allowedToEdit = computed(() => isContentManager.value || isAdmin.value)

  const handleAddClick = () => {
    router.push({ name: '/events/create-item/', state: { from: route.fullPath } })
  }
</script>

<template>
  <div class="wide-responsive relative w-full">
    <PageDecorationImage />

    <div class="border-border bg-surface-bg flex w-full items-center justify-between border-b px-6 pt-8 pb-6">
      <h1 class="heading-md text-heading!">
        {{ $t('navigation_item_announcements') }}
      </h1>

      <NButton
        v-if="allowedToEdit"
        secondary
        strong
        size="small"
        type="primary"
        class="shrink-0 [&_.n-button\_\_content]:gap-1.5"
        data-testid="events-add-button"
        @click="handleAddClick"
      >
        <i
          class="fa-regular fa-plus text-xs"
          aria-hidden="true"
        />
        {{ $t('events_add_item') }}
      </NButton>
    </div>

    <EventsList />
  </div>
</template>
